import React from "react";

import FlyoutMenu from "components/UI/FlyoutMenu";
import { useUserSettings } from "components/Site/Contexts/UserSettings";
import { useBible } from "components/Bible/BibleContainer";
import { useScriptureRouting } from "components/Bible/useScriptureRouting";

import CogIcon from "icons/CogIcon";
import FontSizeLargeIcon from "icons/FontSizeLargeIcon";
import FontSizeSmallIcon from "icons/FontSizeSmallIcon";
import LightModeBrightIcon from "icons/LightModeBrightIcon";
import LightModeDarkIcon from "icons/LightModeDarkIcon";
import FootnotesOffWhiteIcon from "icons/FootnotesOffWhiteIcon";
import FootnotesOnWhiteIcon from "icons/FootnotesOnWhiteIcon";
import FootnotesOnIcon from "icons/FootnotesOnIcon";
import FootnotesOffIcon from "icons/FootnotesOffIcon";
import VerseNumbersOffIcon from "icons/VerseNumbersOffIcon";
import VerseNumbersOnWhiteIcon from "icons/VerseNumbersOnWhiteIcon";
import VerseNumbersOffWhiteIcon from "icons/VerseNumbersOffWhiteIcon";
import VerseNumbersOnIcon from "icons/VerseNumbersOnIcon";

interface ViewSettingsMenuProps {
  anchor?: "left" | "right";
  open?: boolean;
  iconColor: string;
}

export const ViewSettingsMenu: React.FC<ViewSettingsMenuProps> = ({
  anchor = "left",
  open = false,
  iconColor
}) => {
  const {
    fontSize,
    darkMode,
    showFootnotes,
    showVerseNumbers,
    updateSetting
  } = useUserSettings();
  const { biblesById } = useBible();
  const { bibleId, parallelBibleIds } = useScriptureRouting();
  const bibleIds = [bibleId, ...parallelBibleIds];
  const allBiblesDisableFootnotes = bibleIds.every(
    bibleId => biblesById[bibleId]?.meta?.disableFootnotes
  );

  return (
    <FlyoutMenu
      anchor={anchor}
      iconColor={iconColor}
      iconListColor={darkMode ? "white" : "black"}
      icon={CogIcon}
      open={open}
      iconList={[
        {
          icon: FontSizeLargeIcon,
          handler: () => updateSetting("fontSize", fontSize + 2),
          key: "font-larger"
        },
        {
          icon: FontSizeSmallIcon,
          handler: () => updateSetting("fontSize", fontSize - 2),
          key: "font-smaller"
        },
        {
          icon: darkMode ? LightModeBrightIcon : LightModeDarkIcon,
          handler: () => updateSetting("darkMode", !darkMode),
          key: "dark-mode-toggle"
        },
        {
          icon: darkMode
            ? showFootnotes
              ? FootnotesOffWhiteIcon
              : FootnotesOnWhiteIcon
            : showFootnotes
            ? FootnotesOffIcon
            : FootnotesOnIcon,
          handler: () => updateSetting("showFootnotes", !showFootnotes),
          key: "footnotes-toggle",
          disabled: allBiblesDisableFootnotes
        },
        {
          icon: darkMode
            ? showVerseNumbers
              ? VerseNumbersOnWhiteIcon
              : VerseNumbersOffWhiteIcon
            : showVerseNumbers
            ? VerseNumbersOnIcon
            : VerseNumbersOffIcon,
          handler: () => updateSetting("showVerseNumbers", !showVerseNumbers),
          key: "verser-number-toggle"
        }
      ]}
    />
  );
};
